(function ($) {
    'use strict';
    $(document).ready(function () {
        /*
            If there is a main search bar enabled on the screen, the top search icon
            should delegate into it instead of expanding and showing its own form.
        */
        var mainSearchInput = $('#ncver-banner-header-search-input');
        var primarySearch = $('.ncver-primary-search');
        var topSearch = $('#ncver-top-search');
        var scrollTarget;
        if ($(mainSearchInput).is(':visible')) {
            //Make sure it isnt missing
            if ($(topSearch).is(':visible')) {
                scrollTarget = $('.header__hero-search');
                //Scroll the main search section into view
                topSearch.on('click', function () {
                    $('html, body').animate({
                        scrollTop: scrollTarget.offset().top
                    }, 500);
                    mainSearchInput.focus();
                });
            }
        } else if ($(primarySearch).is(':visible')) {
            //Make sure it isnt missing
            if ($(topSearch).is(':visible')) {
                topSearch.on('click', function () {
                    $('html, body').animate({
                        scrollTop: primarySearch.offset().top
                    }, 500);
                    primarySearch.focus();
                });
            }
        } else {
            /*
                Otherwise the top search needs to expand
            */
            if ($(topSearch).is(':visible')) {
                topSearch.on('click', function () {
                    //Set the form active
                    $('.header__search-form--toggled').addClass('header__nav-search-form--active');

                    if ($('.header__nav-search-form--active').length > 0) {
                        //Enable the inner form elements (one time deal)
                        $('#ncver-nav-header-search-input').attr('disabled', false);
                        $('#ncver-nav-header-search-submit').attr('disabled', false);
                        //Focus on the input element
                        $('#ncver-nav-header-search-input').focus();
                    }

                    //When an active form loses focus
                    $('.header__nav-search-form--active').on('focusout', function () {
                        //Remove active class, this will happen when moving between elements inside a form
                        $('.header__search-form--toggled').removeClass('header__nav-search-form--active');
                    });
                    //If another form element catches focus (tabbing between input and submit button)
                    $('.header__search-form--toggled').on('focusin', function () {
                        //Re-add the active class
                        $('.header__search-form--toggled').addClass('header__nav-search-form--active');
                    });
                });
            }
        }
 
        /*
            Prevent search form from being submited until three 
            or more characters are entered
        */
        $('.header__search-form.header__search-form--toggled').on('submit', function (event) {
            var input =  $(event.target).find('input[name=query]')
            if (input.val().length >= 3) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        });

        /*
            Responsive menu is opened via JS, if JS is disabled responsive
            will be shown by default (via CSS) and cant be closed.
        */
        var hamburgerMenu = $('#ncver-responsive-menu-link');
        hamburgerMenu.on('click', function (event) {
            var source = $(event.target);
            var respMenu = source.closest('.header').find('.responsive-menu');
            respMenu.toggleClass('responsive-menu--show');
        });
    });
}(jQuery));